import * as React from "react";
import Dialog from "@mui/material/Dialog";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import Tx from "../Tx";
import { useMemo, useRef, useState } from "react";
import { useEffect } from "react";
import Icn from "../Icn";
import Grid from "@mui/material/Grid";
import { colors } from "../../maps/colors";
import FloorPainter from "../floorPainter/FloorPainter";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar } from "@mui/material";
import { api } from "../../maps/data.js";
import Btn from "../Btn";
import { register, unregister } from "../../domain/socketSlice";
import axios from "axios";
import useZibi from "../../zibi/UseZibi";
import FieldsPlayMode from "../field/FieldsPlayMode";
import Paper from "@mui/material/Paper";
import CoolButtonGroup from "../CoolButtonGroup";
import ShopperCheckinDrawer from "../drawers/ShopperCheckinDrawer";
import ShopperCartDrawer from "../drawers/ShopperCartDrawer";
import styled from "styled-components";
import WeightDragableDialog from "../field/WeightDragableDialog";
import { useSnackbar } from "notistack";

import { ClientJS } from "clientjs";

export default function PlaySiteDialog(props) {
  const ref = useRef(null);
  const { onClose, siteName, siteId } = props;
  const eventName = `play-mode-data-${siteId}`;

  const [logs, setLogs] = useState({}); // State to hold structured logs by name
  const eventStats = useRef({}); // Ref to hold raw event stats

  //   const [audio] = useState(
  //     new Audio(
  //       "https://commondatastorage.googleapis.com/codeskulptor-demos/riceracer_assets/music/start.ogg"
  //     )
  //   );

  const [clientInfo, setClientInfo] = useState({});

  useEffect(() => {
    const client = new ClientJS();

    const info = {
      browser: client.getBrowser(),
      browserVersion: client.getBrowserVersion(),
      os: client.getOS(),
      osVersion: client.getOSVersion(),
      device: client.getDevice(),
      screenPrint: client.getScreenPrint(),
      userAgent: client.getUserAgent(),
      fingerprint: client.getFingerprint(), // Unique client fingerprint
    };

    setClientInfo(info);
  }, []);

  const [productsById, set_productsById] = useZibi("productsById");
  const [drawCircles, s_drawCircles] = useState(false);
  const [showShoppersCart, s_showShoppersCart] = useState(false);
  const [showShoppersCheckin, s_showShoppersCheckin] = useState(false);
  const [draw_shoppers_image, s_draw_shoppers_image] = useState(true);

  const [edges, s_edges] = useState(null);
  const [edge_index, s_edge_index] = useState(0);
  const [circles, s_circles] = useState([]);

  const [shoppers_map, s_shoppers_map] = useState([]);
  const [shopperOnline_list, s_shopperOnline_list] = useState([]);

  const [stats_mode, s_stats_mode] = useZibi("stats_mode");
  const [stats, s_stats] = useZibi("stats");
  const [productsByBarCode, set_productsByBarCode] =
    useZibi("productsByBarCode");
  const [isMouseDown, s_isMouseDown] = useState(false);
  const [simulateSteps, s_simulateSteps] = useState(false);
  const [shopperToSimulate, s_shopperToSimulate] = useState(null);
  const [productsDetection, s_productsDetection] = useState([]);

  const [shelvesDetection, s_shelvesDetection] = useState([]);
  const [poseDetection, s_poseDetection] = useState([]);
  const [indications, s_indications] = useState({});
  const [floor_indications, s_floor_indications] = useState([]);
  const [currentWeight, s_currentWeight] = useState({});
  const [currentWeightSensor, s_currentWeightSensor] = useState(null);
  const [combinedProductDetection, setCombinedProductDetection] = useState([]); // Unified data

  const [, set_shopperProductsCart] = useZibi("shopperProductsCart");

  const highlightZero = (key, value) => {
    switch (key) {
      case "status":
        return value !== "OK" ? "highlight" : "";

        break;
      case "delay":
        return value !== "OK" ? "highlight" : "";

        break;
    }

    return "";
    // return value === 0 || value === null ? "highlight" : "";
  };

  // toast
  const { enqueueSnackbar } = useSnackbar();

  if (Object.keys(currentWeight).length !== 0) {
    // console.log("currentWeight", currentWeight);
  }

  useEffect(() => {
    register(eventName);
    window.addEventListener(eventName, onPlayModeData);
    window.c = 0;

    return () => {
      unregister(eventName);
      window.removeEventListener(eventName, onPlayModeData);
    };
  }, []);

  useEffect(() => {
    // setSitePlayMode(true, []);

    // load site data
    api({
      type: "getEdges",
      data: { siteId: props.siteId },
    }).then((r) => {
      s_edges(r);
      s_edge_index(0);
    });
  }, []);

  useEffect(() => {
    if (!Object.keys(productsByBarCode).length) {
      api({
        type: "getProducts",
        data: { allProducts: true, ignoreCategory: true },
      }).then(({ products }) => {
        const temp = {};
        for (let i = 0; i < products.length; i++) {
          const product = products[i];
          temp[product.barcode] = product;
          productsById[product._id] = product;
        }
        set_productsByBarCode(temp);
        set_productsById({ ...productsById });
      });
    }
  }, []);

  useEffect(() => {
    getShoppersCart();
  }, []);

  const setSitePlayMode = async (enabled, shelves, clientId) => {
    await api({
      type: "setSitePlayMode",
      data: {
        siteId,
        enabled,
        shelves,
        clientId,
      },
    });
  };

  const getShoppersCart = async () => {
    api({
      type: "getShopperCart",
      data: { siteId, status: "ACTIVE" },
    }).then((data) => {
      const tempObj = {};
      data.forEach((item) => {
        if (!tempObj[item.shopperId]) {
          tempObj[item.shopperId] = {
            cart: [],
          };
        }
        item.products.forEach((pro) => {
          tempObj[item.shopperId].cart.push({ productId: pro.productId });
        });
      });
      set_shopperProductsCart(tempObj);
    });
  };

  const getShoppers = () => {
    api({
      type: "getShoppers",
      disableBI: true,
      data: { nonAnon: true },
    }).then((shoppers) => s_shoppers_map(shoppers));
    api({
      type: "getOnlineShoppers",
      disableBI: true,
      data: { siteId },
    }).then((shoppers) => s_shopperOnline_list(shoppers));
  };

  const removeAllShoppersOnlineHandle = async () => {
    s_shopperOnline_list([]);
    await api({
      type: "removeAllShoppersFromSite",
      data: { siteId },
    });
  };

  const allShoppersAsMapObj = useMemo(() => {
    if (!shoppers_map.length) {
      return null;
    }
    const temp = {};
    shoppers_map
      .filter((s) => s && !!s._id)
      .forEach((shopper) => {
        temp[shopper._id] = shopper;
      });
    return temp;
  }, [shoppers_map]);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     getShoppers();
  //   }, 2000);
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  const shoppersToDisplay = shoppers_map
    .filter((s) => s && !!s._id)
    .filter((shopper) => {
      const shopperOnline = shopperOnline_list
        .filter((s) => s && !!s._id)
        .find((sho) => sho.shopperId === shopper._id);
      return !shopperOnline;
    });

  function handleClose(e) {
    setSitePlayMode(false, [], clientInfo.fingerprint);

    onClose(e);
  }

  const productCartHandle = async (productId, shopperId, isRemove) => {
    if (isRemove) {
      set_shopperProductsCart((prevItems) => {
        const newShopperCartObj = { ...prevItems };
        let removed = false;
        const newCart = newShopperCartObj?.[shopperId]?.cart?.filter((prod) => {
          if (prod.productId === productId && !removed) {
            removed = true;
            return false;
          }
          return true;
        });
        newShopperCartObj[shopperId] = {
          ...(newShopperCartObj[shopperId] || {}),
          cart: newCart,
        };
        return newShopperCartObj;
      });
    } else {
      let product = null;
      if (productsById[productId]) {
        product = productsById[productId];
      } else {
        const { products } = await api({
          type: "getProducts",
          data: { ignoreCategory: true, productIds: [productId] },
        });
        if (products.length) {
          product = products[0];
          productsById[productId] = product;
          set_productsById({ ...productsById });
        }
      }
      if (product) {
        set_shopperProductsCart((prevItems) => {
          const newShopperCartObj = { ...prevItems };
          if (!newShopperCartObj[shopperId]?.cart) {
            newShopperCartObj[shopperId] = {
              cart: [],
            };
          }
          newShopperCartObj?.[shopperId]?.cart?.unshift({ productId });
          return newShopperCartObj;
        });
      }
    }
  };

  // const productDetectionHandle = (data) => {
  //   // console.log("data", data);
  //   if (data?.length) {
  //     s_productsDetection(data);
  //   }
  // };

  const productDetectionHandle = (newData) => {
    console.log(JSON.stringify(newData, null, 2));
    s_productsDetection(newData);
    if (!Array.isArray(newData)) {
      console.error("newData is not an array:", newData);
      return;
    }
    setCombinedProductDetection((prevData) => {
      // Combine data
      const combined = [...prevData, ...newData];
      console.log("combined", combined);

      // Remove duplicates if necessary (e.g., by unique productId)
      const uniqueData = combined.reduce((acc, item) => {
        // Remove the previous item with the same sensorId if it exists
        const index = acc.findIndex(
          (entry) => entry.sensorId === item.sensorId
        );

        // If the sensorId already exists, remove the previous item
        if (index !== -1) {
          acc.splice(index, 1); // Removes the old item at the found index
        }

        // Add the new item to the accumulator
        acc.push(item);

        // Return the updated accumulator
        return acc;
      }, []);

      s_productsDetection(uniqueData);

      return uniqueData;
    });
  };

  const playSound = () => {
    // audio.play();
  };

  const onPlayModeData = async (playModeData) => {
    const {
      type,
      circles,
      shopperId,
      productId,
      data,
      shelfId,
      totalWeightChange,
      // eventStats,
    } = playModeData.detail;

    switch (type) {
      case "stats": {
        const { name, ...rest } = playModeData.detail.data;

        // Update eventStats to keep only the last log per name
        eventStats.current[name] = rest;

        // Update logs state for rendering
        setLogs({ ...eventStats.current });

        break;
      }
      case "floorDetection": {
        s_circles(circles);

        const shopperIds = circles.map((c) => c.userId);
        const shopperIdsKey = circles.map((c) => c.userId_key);
        const shopperIdsFusion = circles.map((c) => c.userId_fusion);

        // stats
        if (zibi.stats_mode) {
          const _stats = Object.assign(zibi.stats, {});
          shopperIds.forEach((shopperId) => {
            const kkk = !!shopperId ? shopperId : "noUserId";
            if (kkk !== "noUserId") {
              _stats[kkk]++;
              _stats.total++;
              _stats.totalCnn++;
            }
          });
          shopperIdsFusion.forEach((shopperId) => {
            const kkk = !!shopperId ? shopperId : "noUserId";
            if (kkk !== "noUserId") {
              if (!_stats[`${kkk}_fusion`]) {
                _stats[`${kkk}_fusion`] = 0;
              }
              _stats.totalFusion++;
              _stats[`${kkk}_fusion`]++;
            }
          });
          shopperIdsKey.forEach((shopperId) => {
            const kkk = !!shopperId ? shopperId : "noUserId";
            if (kkk !== "noUserId") {
              if (!_stats[`${kkk}_key`]) {
                _stats[`${kkk}_key`] = 0;
              }
              _stats.totalKey++;
              _stats[`${kkk}_key`]++;
            }
          });
          s_stats(_stats);
        }

        // const shoppers_list_ids = shoppers_map.filter(s => !!s).map(s => s._id);

        // let missingIds = shopperIds.filter(s => !!s).filter(shopperId => !shoppers_list_ids.includes(shopperId));

        // if (!isLoadingShoppers && missingIds.length > 0) {
        //     s_isLoadingShoppers(true);
        //     let newShoppers = await api({
        //         type: 'getShoppers', data: {
        //             shopperIds: missingIds
        //         }
        //     });
        //     s_shoppers_map(shoppers_map.concat(newShoppers));
        //     setTimeout(() => s_isLoadingShoppers(false), 2000);
        // }
        break;
      }
      case "shopperEnter":
        playSound();
        await getShoppers();
        break;
      case "shopperLeft":
        await getShoppers();
        await getShoppersCart();
        break;
      case "addProductToCart":
        await productCartHandle(productId, shopperId);
        break;
      case "removeProductFromCart":
        await productCartHandle(productId, shopperId, true);
        break;
      case "productDetection":
        productDetectionHandle(data);

        break;
      case "shelvesDetection":
        data?.length && s_shelvesDetection(data);

        break;
      case "indication":
        if (data?.length) {
          s_floor_indications(data.filter((i) => i.type === "floor"));
          const tempData = {};
          for (
            let i = 0;
            i < data.filter((i) => i.type !== "floor").length;
            i++
          ) {
            const item = data[i];
            if (!tempData[item.data.shelfId]) {
              tempData[item.data.shelfId] = {
                items: [],
              };
            }
            tempData[item.data.shelfId].items.push(item);
          }
          s_indications(tempData);
        }
        break;
      case "toast":
        enqueueSnackbar(data?.text, { variant: data?.variant || "info" });
        break;
      case "poseDetection":
        s_poseDetection(data);
        break;
      case "eventUpdated":
        getShoppersCart();
        break;
      case "weightUpdate":
        s_currentWeight((prevState) => {
          const stateCopy = { ...prevState };
          stateCopy[shelfId] = totalWeightChange;
          return stateCopy;
        });
        break;
      default:
        console.error("this type is not handled");
    }
  };

  const showDrawer = showShoppersCart || showShoppersCheckin;

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullScreen={true}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar style={{ background: colors.GRAY4, minHeight: 60 }}>
          <CloseIcon
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          />
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            <Icn style={{ position: "relative", top: 4, color: "white" }}>
              store
            </Icn>
            <Tx>site.playMode</Tx> [{siteName}]
          </Typography>

          <div style={{ display: "flex", height: 50 }}>
            <CoolButtonGroup label="Floors">
              {edges &&
                edges.map((edge, idx) => {
                  return (
                    <Btn
                      key={`btn_${idx}`}
                      customtheme="white"
                      onClick={() => {
                        s_edge_index(idx);
                      }}
                      variant={edge_index === idx ? "contained" : "outlined"}
                    >
                      {edge.floorName}
                    </Btn>
                  );
                })}
            </CoolButtonGroup>
            <Divider
              orientation="vertical"
              flexItem={true}
              style={{ borderColor: "rgba(255, 255, 255, 0.25)" }}
            />
            <CoolButtonGroup label="Playmode">
              <Btn
                onClick={() => s_drawCircles(!drawCircles)}
                variant={drawCircles ? "contained" : "outlined"}
                customtheme="teal"
              >
                Draw Circles
              </Btn>
              <Btn
                onClick={() => s_draw_shoppers_image(!draw_shoppers_image)}
                variant={draw_shoppers_image ? "contained" : "outlined"}
                customtheme="teal"
              >
                Draw Shopper Image
              </Btn>
              <Btn
                onClick={() => s_simulateSteps(!simulateSteps)}
                variant={simulateSteps ? "contained" : "outlined"}
                customtheme="teal"
              >
                Simulate Steps
              </Btn>
            </CoolButtonGroup>
            <Divider
              orientation="vertical"
              flexItem={true}
              style={{ borderColor: "rgba(255, 255, 255, 0.25)" }}
            />
            <CoolButtonGroup label="Shoppers">
              <Btn
                onClick={() => {
                  s_showShoppersCart(!showShoppersCart);
                  s_showShoppersCheckin(false);
                }}
                variant="text"
                customtheme="teal"
              >
                Shoppers Cart
              </Btn>
              <Btn
                onClick={() => {
                  s_showShoppersCart(false);
                  s_showShoppersCheckin(!showShoppersCheckin);
                }}
                variant="text"
                customtheme="teal"
              >
                Show Checkin
              </Btn>
            </CoolButtonGroup>
          </div>
        </Toolbar>
      </AppBar>

      <DialogWrapperStyled
        style={{
          gridTemplateColumns: showDrawer ? "80% 20%" : "100% 0",
        }}
      >
        <DialogContent style={{ background: colors.GRAY3 }}>
          <Grid container spacing={2} style={{ height: "calc(100vh - 90px)" }}>
            <Grid item xs={12} style={{ height: "100%", paddingTop: 6 }}>
              <Grid container spacing={1} style={{ height: "100%" }}>
                <Grid item xs={4} style={{ height: "50%" }}>
                  <Paper style={{ height: "100%" }}>
                    <div
                      style={{
                        height: "100%",
                        cursor: `${
                          isMouseDown && simulateSteps ? "wait" : "default"
                        }`,
                      }}
                      ref={ref}
                      onMouseMove={(e) => {
                        if (isMouseDown && simulateSteps && shopperToSimulate) {
                          const positionX =
                            e.clientX - ref.current.offsetLeft - 20;
                          const positionY =
                            e.clientY - ref.current.offsetTop - 20;
                          console.log(shopperOnline_list[0]._id);
                          axios.post("http://localhost:3002/simulate-step", {
                            shopperId: shopperToSimulate._id,
                            x: positionX,
                            y: positionY,
                          });
                        }
                      }}
                      onMouseDown={() => {
                        s_isMouseDown(true);
                      }}
                      onMouseUp={() => {
                        s_isMouseDown(false);
                      }}
                    >
                      <FloorPainter
                        shoppers_list={shoppers_map}
                        indications={floor_indications}
                        circles={circles}
                        site={edges}
                        floorPos={edge_index}
                        siteId={siteId}
                        drawCircles={drawCircles}
                        draw_shoppers_image={draw_shoppers_image}
                      ></FloorPainter>
                      <h3>Site Logs: {clientInfo.fingerprint} </h3>

                      {Object.keys(logs).length > 0 ? (
                        Object.entries(logs).map(([name, data]) => (
                          <LogCard key={name}>
                            <h2>{name}</h2>
                            <pre>
                              {/* Main Log Entries */}
                              {Object.entries(data).map(([key, value]) => (
                                <LogEntry
                                  key={key}
                                  className={highlightZero(key, value)}
                                >
                                  <strong>{key}:</strong>
                                  {value !== null &&
                                  typeof value === "object" ? (
                                    <pre></pre>
                                  ) : (
                                    JSON.stringify(value, null, 2)
                                  )}
                                </LogEntry>
                              ))}
                            </pre>
                          </LogCard>
                        ))
                      ) : (
                        <p>No logs available.</p>
                      )}
                    </div>
                  </Paper>
                </Grid>
                <Grid item xs={8} style={{}}>
                  {!!edges?.length && (
                    <FieldsPlayMode
                      poseDetection={poseDetection}
                      indications={indications}
                      currentWeight={currentWeight}
                      shelvesDetection={shelvesDetection}
                      productsDetection={productsDetection}
                      edge={edges[edge_index]}
                      openWeightHandle={(e, sensorId) => {
                        s_currentWeightSensor(sensorId);
                      }}
                      siteId={siteId}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <PersistentDialog
          style={{
            width: showDrawer ? "100%" : 0,
            position: "relative",
            visibility: showDrawer ? "visible" : "hidden",
            opacity: showDrawer ? 1 : 0,
            right: 0,
            overflow: "hidden",
          }}
        >
          <CloseIcon
            color="inherit"
            onClick={() => {
              s_showShoppersCheckin(false);
              s_showShoppersCart(false);
            }}
            style={{ cursor: "pointer", marginTop: 10, marginLeft: 10 }}
            aria-label="close"
          />
          {showShoppersCheckin && (
            <ShopperCheckinDrawer
              allShoppersAsMapObj={allShoppersAsMapObj}
              shopperOnline_list={shopperOnline_list}
              shopperToSimulate={shopperToSimulate}
              simulateSteps={simulateSteps}
              s_shopperToSimulate={s_shopperToSimulate}
              stats_mode={stats_mode}
              stats={stats}
              siteId={siteId}
              s_stats={s_stats}
              s_stats_mode={s_stats_mode}
              shoppersToDisplay={shoppersToDisplay}
              removeAllShoppersOnlineHandle={removeAllShoppersOnlineHandle}
            />
          )}
          {showShoppersCart && (
            <ShopperCartDrawer
              allShoppersAsMapObj={allShoppersAsMapObj}
              shopperOnline_list={shopperOnline_list}
            />
          )}
        </PersistentDialog>

        {currentWeightSensor && (
          <WeightDragableDialog
            weight={currentWeight?.[currentWeightSensor]}
            open={!!currentWeightSensor}
            handleClose={() => {
              s_currentWeightSensor(null);
            }}
          />
        )}
      </DialogWrapperStyled>
    </Dialog>
  );
}

const PersistentDialog = styled.div`
  transition: right 0.3s ease;
`;

const DialogWrapperStyled = styled.div`
  transition: 0.4s ease;
  display: grid;
`;

const LogCard = styled.div`
  flex: 1 1 calc(25% - 20px);
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #f9f9f9;
`;

const LogEntry = styled.div`
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;

  &.highlight {
    color: red;
  }
`;
